<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/weier/process/preparation/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdan')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanxian')">
            <el-select v-model="yt.conditions.equipmentIds" :multiple="true">
              <el-option style="width: 350px" v-for="(item,index) in productionList" :label="item.labelName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('qingxianzhuangtai')">
            <yi_dictionary_select :type="'CLEAR_LINE_STATUS'" :ids.sync="yt.conditions.clearLineStatus"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('beiliaozhuangtai')">
            <el-select v-model="yt.conditions.stockStatus">
              <el-option :label="$t('weichuli')" :value="0"></el-option>
              <el-option :label="$t('yiwancheng')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('tiaojizhuangtai')">
            <yi_dictionary_select :type="'PREPARATION_DEBUG_EQUIPMENT_STATUS'" :ids.sync="yt.conditions.debugEquipmentStatus"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifousongjian')">
            <yi_dictionary_select :type="'SYSTEM_YES_NO'" :ids.sync="yt.conditions.isSent"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouteshusongjian')">
            <yi_dictionary_select :type="'SYSTEM_YES_NO'" :ids.sync="yt.conditions.isSpecialSent"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc', woStatus: [1, 2, 3, 4, 5, 6, 7, 8] })">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <template #beiliaozhuangtai="scope">
        <!-- 备料状态 -->
        <template v-if="scope.row.stockStatus == 0">
          <span>{{ $t('weichuli') }}</span>
        </template>
        <template v-if="scope.row.stockStatus == 1">
          <span>{{ $t('yiwancheng') }}</span>
        </template>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.stockStatus == 0">
            <el-button type="text" @click="finishPreparation(scope.row)" :loading="scope.row.finishPreparationLoading" v-if="utils.checkPower('web_production_prepartion')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-备料完成' } }">
              {{ $t('beiliaowancheng') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.stockStatus == 1">
            <el-button type="text" @click="cancelPreparation(scope.row)" :loading="scope.row.cancelPreparationLoading" v-if="utils.checkPower('web_production_prepartion')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-取消备料' } }">
              {{ $t('quxiaobeiliao') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.clearLineStatus == 0">
            <el-button type="text" @click="startClearLine(scope.row)" :loading="scope.row.startClearLineLoading" v-if="utils.checkPower('web_screen_printing_preparation_clear_line_start')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-开始清线' } }">
              {{ $t('kaishiqingxian') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.clearLineStatus == 1">
            <el-button type="text" @click="endClearLine(scope.row)" :loading="scope.row.endClearLineLoading" v-if="utils.checkPower('web_screen_printing_preparation_clear_line_end')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-清线结束' } }">
              {{ $t('qingxianjieshu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_screen_printing_management_prenatal_preparation_list',
  computed: {},
  components: {},
  data() {
    return {
      productionList:[],
      columns: [
        {
          label: 'shengchangongdan',
          prop: 'no',
          width: 160
        },
        {
          label: 'guishuchejian',
          prop: 'org.name',
          width: 160
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'wuliaobianma',
          prop: 'basicMaterial.code',
          width: 160
        },
        {
          label: 'wuliaomingcheng',
          prop: 'basicMaterial.name',
          width: 160
        },
        {
          label: 'liaohao',
          prop: 'basicMaterial.no',
          width: 100
        },
        {
          label: 'tiaojikaishishijian',
          prop: 'debugEquipmentStartTime',
          type: 'time',
          width: 160
        },
        {
          label: 'tiaojijieshushijian',
          prop: 'debugEquipmentEndTime',
          type: 'time',
          width: 160
        },
        {
          label: 'tiaojirenyuan',
          prop: 'equipmentDebuggerObject.nickname',
          width: 120
        },
        {
          label: 'shifousongjian',
          prop: 'isSent',
          type: 'dictionary',
          key: 'SYSTEM_YES_NO'
        },
        {
          label: 'jianyandanhao',
          prop: 'inspection.inspectionNo',
          width: 150
        },
        {
          label: 'jianyanrenyuan',
          prop: 'inspectorObject.nickname'
        },
        {
          label: 'tiaojizhuangtai',
          prop: 'debugEquipmentStatus',
          type: 'dictionary_tag',
          key: 'PREPARATION_DEBUG_EQUIPMENT_STATUS'
        },
        {
          label: 'beiliaozhuangtai',
          prop: 'status',
          type: 'slot'
        },
        {
          label: 'qingxianzhuangtai',
          prop: 'clearLineStatus',
          type: 'dictionary_tag',
          key: 'CLEAR_LINE_STATUS'
        },
        {
          label: 'qingxianrenyuan',
          prop: 'clearLinerObject.nickname'
        },
        {
          label: 'qingxiankaishishijian',
          prop: 'clearLineStartTime',
          type: 'time',
          width: 160
        },
        {
          label: 'qingxianjieshushijian',
          prop: 'clearLineEndTime',
          type: 'time',
          width: 160
        },
        {
          label: 'shifouteshusongjian',
          prop: 'isSpecialSent',
          type: 'dictionary',
          key: 'SYSTEM_YES_NO'
        },
        {
          label: 'teshusongjiandanhao',
          prop: 'specialInspection.no',
          width: 160
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },

  created() {
    setTimeout(() => {
      this.getProcessEquipmentList();
      this.yt.conditions = {
        orderBy: 'createTime desc',
        woStatus: [1, 2, 3, 4, 5, 6, 7, 8]
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    getProcessEquipmentList(){
      this.http.get('/custom/weier/process/plan/getProcessEquipmentList').then((res) => {
        this.productionList = res.data;
        for(let i = 0; i < this.productionList.length; i++) {
          const labelName = this.productionList[i]['name']+' | '+this.productionList[i]['sn']
          this.$set(this.productionList[i],'labelName',labelName)
        }
      }).catch((msg) => {
        this.utils.errorMessage(msg);
      });
    },
    startClearLine(editObj) {
      this.$set(editObj, 'startClearLineLoading', true);
      let params = editObj;
      this.http.post('/custom/weier/process/preparation/startClearLine', params.id).then(res => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(msg => {
        this.utils.errorMessage(msg);
      }).finally(() => {
        this.$set(editObj, 'startClearLineLoading', false);
      });
    },
    endClearLine(editObj) {
      let params = editObj;
      this.$set(editObj, 'endClearLineLoading', true);
      this.http.post('/custom/weier/process/preparation/endClearLine', params.id).then(res => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(msg => {
        this.utils.errorMessage(msg);
      }).finally(() => {
        this.$set(editObj, 'endClearLineLoading', false);
      });
    },
    finishPreparation(editObj) {
      let params = editObj;
      params.stockStatus = 1;
      this.$set(editObj, 'finishPreparationLoading', true);
      this.http
        .post('/web/prepartion/update', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.$set(editObj, 'finishPreparationLoading', false);
        });
    },
    cancelPreparation(editObj) {
      let params = editObj;
      this.$set(editObj, 'cancelPreparationLoading', true);
      params.stockStatus = 0;
      this.http
        .post('/web/prepartion/update', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.$set(editObj, 'cancelPreparationLoading', false);
        });
    },
  }
};
</script>
